// import { Box } from '@mui/material';
// import Container from '@src/components/commons/containerPage.common'; // Ensure this import is correct
import React from 'react';

// import { useLocation } from 'react-router-dom';
import PropertiesListPage from './propertiesList.page';

// import { mainRoute } from '@src/utils/consts/routesMainMenu.const'; // Import mainRoute for paths

function AnalyticsPage() {
  // const path = useLocation().pathname;

  // Define explicit breadcrumb items for the Analytics page
  // const breadcrumbItems = [
  //   { label: 'MISC', path: '#' }, // Example: A category link, or '#' if no specific page
  //   { label: 'ANALYTICS', path: mainRoute.MISC_ANALYTICS }, // Link to the analytics overview
  // ];

  return <PropertiesListPage />;

  // return (
  //   <Container pathUrl={path} breadcrumbItems={breadcrumbItems}> {/* Pass breadcrumbItems here */}
  //     <Box>
  //       <PropertiesListPage />
  //     </Box>
  //   </Container>
  // );
}

export default AnalyticsPage;
